import { Serializable } from "models/domain/interfaces/serializable";
import { Zipcode } from "models/domain/zipcode.domain";


export class Address implements Serializable {
    constructor(
        private _state: string,
        private _city: string,
        private _neighborhood: string,
        private _streetName: string,
        private _streetType: string,
        private _addressNumber: string,
        private _addressComplement?: string,
        private _zipcode?: Zipcode
    ) { }

    public asJson(): object {
        return {
            uf: this.state,
            municipio: this.city,
            bairro: this.neighborhood,
            logradouro: this.streetName,
            tipoLogradouro: this.streetType,
            numero: this.addressNumber,
            complemento: this.addressComplement,
            cep: this.zipcode?.getWithoutMask()
        }
    }

    public get zipcode(): Zipcode | undefined {
        return this._zipcode;
    }

    public get addressComplement(): string | undefined {
        return this._addressComplement;
    }

    public get addressNumber(): string {
        return this._addressNumber;
    }

    public get streetType(): string {
        return this._streetType;
    }

    public get streetName(): string {
        return this._streetName;
    }

    public get neighborhood(): string {
        return this._neighborhood;
    }

    public get city(): string {
        return this._city;
    }

    public get state(): string {
        return this._state;
    }
}